import React from 'react'
import { resolveThemeMode } from '../lib/themeMode'
import { useSettings } from '../stateData/settings'
import { useSignupState } from './useSignupState'

export const useResolvedThemeMode = (): 'light' | 'dark' => {
  const settingsState = useSettings()
  const signupState = useSignupState()

  const enableDarkModeSignup = settingsState.data?.enableDarkModeSignup
  const appMode = signupState.onboarding?.sessionContext?.app?.mode
  const resolvedMode = resolveThemeMode(enableDarkModeSignup, appMode)
  const isStyleguide = !!(globalThis as any).__STYLEGUIDE__

  const getStyleguideMode = (): 'light' | 'dark' | null => {
    const mode = sessionStorage.getItem('styleguide-theme')
    return mode === 'dark' || mode === 'light' ? mode : null
  }

  const [styleguideMode, setStyleguideMode] = React.useState<
    'light' | 'dark' | null
  >(() => (isStyleguide ? getStyleguideMode() : null))

  React.useEffect(() => {
    if (!isStyleguide) return

    const handler = () => {
      setStyleguideMode(getStyleguideMode())
    }

    globalThis.addEventListener('styleguide-theme-change', handler)

    return () => {
      globalThis.removeEventListener('styleguide-theme-change', handler)
    }
  }, [isStyleguide])

  if (isStyleguide && styleguideMode) {
    return styleguideMode
  }

  return resolvedMode
}
